import React, { createContext, useContext, useState, ReactNode } from 'react';
import FeedbackModal from '../components/Layout/FeedbackModal';

interface FeedbackData {
    initialSubject?: string;
    initialDescription?: string;
    hiddenMetadata?: string;
}

interface FeedbackContextType {
    openFeedbackModal: (data?: FeedbackData) => void;
    closeFeedbackModal: () => void;
    isFeedbackModalOpen: boolean;
}

const FeedbackContext = createContext<FeedbackContextType | undefined>(undefined);

export const FeedbackProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [feedbackData, setFeedbackData] = useState<FeedbackData>({});

    const openFeedbackModal = (data?: FeedbackData) => {
        setFeedbackData(data || {});
        setIsOpen(true);
    };

    const closeFeedbackModal = () => {
        setIsOpen(false);
        setFeedbackData({});
    };

    return (
        <FeedbackContext.Provider value={{ openFeedbackModal, closeFeedbackModal, isFeedbackModalOpen: isOpen }}>
            {children}
            <FeedbackModal
                isOpen={isOpen}
                onClose={closeFeedbackModal}
                initialSubject={feedbackData.initialSubject}
                initialDescription={feedbackData.initialDescription}
                hiddenMetadata={feedbackData.hiddenMetadata}
            />
        </FeedbackContext.Provider>
    );
};

export const useFeedback = () => {
    const context = useContext(FeedbackContext);
    if (context === undefined) {
        throw new Error('useFeedback must be used within a FeedbackProvider');
    }
    return context;
};
